// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5 {
  direction: rtl;
  font-size: revert;
  color: blue;
}

mat-card {
  padding: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
}

h6 {
  font-size: smaller;
  font-family: "IRANSansNumber";
  text-align: right;
  margin-top: 20px;
  margin-right: 20px;
}

mat-form-field {
  width: 97%;
  direction: rtl;
}

mat-label {
  font-size: small;
  direction: rtl;
  color: blue;
}

.button-style {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  margin-right: auto;
  margin-top: 15px;
  background-color: rgba(0, 0, 255, 0.7803921569);
  color: white;
  margin-left: 10px;
}

input {
  text-align: center;
  font-size: small;
}

mat-grid-list {
  margin: auto;
}

.field-parent {
  display: flex;
  direction: rtl;
}

.parent-field {
  display: flex;
}

.field-form {
  width: 25%;
}`, "",{"version":3,"sources":["webpack://./src/app/features/affiliate-marketing/affiliate-marketing.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/affiliate-marketing/affiliate-marketing.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,iBAAA;EACA,WAAA;ACCJ;;ADCA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;ACEJ;;ADAA;EACI,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;ACGJ;;ADDA;EACE,UAAA;EACA,cAAA;ACIF;;ADFA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;ACKJ;;ADHA;EACI,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,YAAA;EACA,iBAAA;ACMJ;;ADJE;EACE,kBAAA;EACA,gBAAA;ACOJ;;ADLE;EACE,YAAA;ACQJ;;ADNE;EACE,aAAA;EACA,cAAA;ACSJ;;ADPE;EACE,aAAA;ACUJ;;ADRE;EACE,UAAA;ACWJ","sourcesContent":["h5{\r\n    direction: rtl;\r\n    font-size: revert;\r\n    color: blue;\r\n}\r\nmat-card{\r\n    padding: 20px;\r\n    margin-top: 5px;\r\n    margin-bottom: 5px;\r\n}\r\nh6{\r\n    font-size: smaller;\r\n    font-family: 'IRANSansNumber';\r\n    text-align: right;\r\n    margin-top: 20px;\r\n    margin-right: 20px;\r\n}\r\nmat-form-field{\r\n  width: 97%;\r\n  direction: rtl;\r\n}\r\nmat-label{\r\n    font-size: small;\r\n    direction: rtl;\r\n    color: blue;\r\n}\r\n.button-style{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 120px;\r\n    margin-right: auto;\r\n    margin-top: 15px;\r\n    background-color: #0000ffc7;\r\n    color: white;\r\n    margin-left: 10px;\r\n  }\r\n  input{\r\n    text-align: center;\r\n    font-size: small;\r\n  }\r\n  mat-grid-list{\r\n    margin: auto;\r\n  }\r\n  .field-parent{\r\n    display: flex;\r\n    direction: rtl;\r\n  }\r\n  .parent-field{\r\n    display: flex;\r\n  }\r\n  .field-form{\r\n    width: 25%;\r\n  }","h5 {\n  direction: rtl;\n  font-size: revert;\n  color: blue;\n}\n\nmat-card {\n  padding: 20px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\nh6 {\n  font-size: smaller;\n  font-family: \"IRANSansNumber\";\n  text-align: right;\n  margin-top: 20px;\n  margin-right: 20px;\n}\n\nmat-form-field {\n  width: 97%;\n  direction: rtl;\n}\n\nmat-label {\n  font-size: small;\n  direction: rtl;\n  color: blue;\n}\n\n.button-style {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  margin-right: auto;\n  margin-top: 15px;\n  background-color: rgba(0, 0, 255, 0.7803921569);\n  color: white;\n  margin-left: 10px;\n}\n\ninput {\n  text-align: center;\n  font-size: small;\n}\n\nmat-grid-list {\n  margin: auto;\n}\n\n.field-parent {\n  display: flex;\n  direction: rtl;\n}\n\n.parent-field {\n  display: flex;\n}\n\n.field-form {\n  width: 25%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
